import { Subscriber } from 'types/electionService';
import { SubscriberElectionPresenter, SubscriberElectionSource } from './types';

/** Maps a BE subscriber into the election-only presenter. */
export function mapSubscriberToElectionPresenter(subscriber: SubscriberElectionSource): SubscriberElectionPresenter {
  return {
    id: subscriber.id,
    employeeClass: subscriber.employeeClass,
    choice: subscriber.choice ?? [],
    interestedProductLines: subscriber.interestedProductLines ?? [],
    productLineToCarrier: subscriber.productLineToCarrier,
  };
}

export function dependentIdsFromSubscriber(subscriber: Pick<Subscriber, 'custom'>): string[] {
  return (subscriber.custom.dependents ?? []).map((dependent) => dependent.id);
}
